import { LuSearch } from "react-icons/lu";

export default {
  row1 : [
    {
      column: "column1",
      columnWidth: "95%",
      rows: {
        row1: [
          {
            name: "importerHighSeaSellerName",
            label: "Seller Name",
            component: "text-field",
            width: "100%",
            type: "autocomplete",
            endpoint:"getCustomers",
            autofillTargets: {
                importerHighSeaSellerAddressId : "address",
                address: "addressLine",
                importerHighSeaSellerIECodeNo: "ieCodeNumber",
                importerHighSeaSellerCity: "city",
                importerHighSeaSellerCountry: "country",
                importerHighSeaSellerPostalCode: "pincode",
               importerHighSeaSellerBranchSNO:"branchNo"
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row2: [
          {
            name: "importerHighSeaSellerAddressId",
            label: "Address",
            component: "dropdown",
            width: "100%",
            type: "autocomplete",
            defaultValue: "", // ✅ Add this
          },
         
        ],
        row3: [
             {
            name: "address", // lowercase (different from Address)
            component: "textarea",
            disabled: true,
            width: "100%",
            height: 60,
            defaultValue: "123 Dummy Street, Example City",
            py: 2,
          },
        ],
        row4: [
          {
            name: "importerHighSeaSellerBranchSNO",
            label: "Branch No",
            component: "text-field",
            iconName: "Search",
            width: "40%",
            dataType:"int"
          },
          {
            name:"importerHighSeaSellerIECodeNo",
            label:"IE Code No",
            component:"text-field",
          },
        ],
        row5: [
          {
            name: "importerHighSeaSellerCity",
            label: "City",
            component: "text-field",
            iconName: "Search",
            width: "50%",
          },
          {
            name: "importerHighSeaSellerPostalCode",
            label: "Postal Code",
            component: "text-field",
            endIconName: "LuSearch",
            width: "50%",
          },
        ],
         row6: [
          {
            name: "importerHighSeaSellerCountry",
            label: "Country",
            component: "text-field",
            endIconName: "LuSearch",
            width: "100%",
            icon : LuSearch,
            endpoint: "getCountry",
            type: "autocomplete",
          },
        ]
       
      },
    }
    
  ]
}
  
